import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ResponsibilitiesService } from "../../services/responsibilities.service";
import { ErrorHandlerService } from "src/app/shared/error-handler.service";
import { Responsibility } from "../../responsibility.model";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSort, Sort } from "@angular/material/sort";
import Swal from "sweetalert2";

@Component({
  selector: "app-responsibilities-list",
  templateUrl: "./responsibilities-list.component.html",
  styleUrls: ["./responsibilities-list.component.css"],
})
export class ResponsibilitiesListComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ["name", "officeFantasyName", "actions"];
  dataSource = new MatTableDataSource<Responsibility>([]);
  loading = false;

  currentPage = 0;
  pageSize = 10;
  totalElements = 0;
  sortField = "name";
  sortDirection = "asc";

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private responsibilitiesService: ResponsibilitiesService,
    private toast: ToastrService,
    public router: Router,
    private errorHandlerService: ErrorHandlerService,
  ) {}

  ngOnInit(): void {
    this.loadResponsibilities();
  }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe((sort: Sort) => this.onSortChange(sort));
  }

  private loadResponsibilities(): void {
    this.loading = true;
    this.responsibilitiesService
      .findAllPaged(this.currentPage, this.pageSize, this.sortField, this.sortDirection)
      .subscribe({
        next: (response) => {
          if (response) {
            this.dataSource.data = response.content;
            this.totalElements = response.totalElements;
          }
          this.loading = false;
        },
        error: (error) => {
          this.loading = false;
          this.errorHandlerService.handle(error, "Erro ao buscar Cargos");
        },
      });
  }

  onPageChange(event: PageEvent): void {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadResponsibilities();
  }

  onSortChange(sort: Sort): void {
    this.sortField = sort.active;
    this.sortDirection = sort.direction || "asc";
    this.currentPage = 0;
    this.loadResponsibilities();
  }

  applyFilter(event: Event): void {
    const value = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = value;
  }

  onEdit(responsibility: Responsibility): void {
    this.router.navigate(["/responsibilities/edit/", responsibility.id]);
  }

  onDelete(responsibility: Responsibility): void {
    Swal.fire({
      title: `Tem certeza que deseja desativar o cargo "${responsibility.name}"?`,
      text: "Você não poderá voltar atrás após desativar!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "green",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, desativar agora!",
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.responsibilitiesService.delete(responsibility.id).subscribe({
          next: () => {
            this.toast.success(`O cargo ${responsibility.name} foi desativado com sucesso.`);
            this.loadResponsibilities();
          },
          error: (error) => {
            this.loading = false;
            this.errorHandlerService.handle(error, "Erro ao deletar cargo selecionado.");
          },
        });
      }
    });
  }
}
